/* eslint-disable react/jsx-one-expression-per-line */
import { ReactElement } from 'react';
import { ErrorPage } from '@components';
import { useFormikContext } from 'formik';
import { iExtensionFormValues } from '@services/ExtensionService';

function ExtensionErrorPage(): ReactElement {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { values }: { values: iExtensionFormValues } = useFormikContext();
    return (
      <>
        <ErrorPage errorMessage={values.submissionError} />
      </>
    );
}

export default ExtensionErrorPage;
